import { render, staticRenderFns } from "./zhuanta.vue?vue&type=template&id=4bb4a252&"
import script from "./zhuanta.vue?vue&type=script&lang=js&"
export * from "./zhuanta.vue?vue&type=script&lang=js&"
import style0 from "./zhuanta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports